import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function ChemquoteExportModalFooter({ isFormAcceptable, isBusy, apply }) {
  return (
    <div className="exportModal__footer">
      <ButtonWithIcon
        type="primary"
        size="small"
        sprite="ChevronRight"
        iconRight
        onClick={apply}
        disabled={!isFormAcceptable || isBusy}
        className="e2e-modal-apply">
        Export
      </ButtonWithIcon>
    </div>
  );
}

ChemquoteExportModalFooter.propTypes = {
  isFormAcceptable: PropTypes.bool,
  isBusy: PropTypes.bool,
  apply: PropTypes.func.isRequired,
};

export default ChemquoteExportModalFooter;
